export default __webpack_public_path__ + "static/media/arrow-straight-line.24150669.svg";